export const getLabels = (originalArray, labels) => originalArray.map((item) => {
  const calculatedLabels = labels.filter((label) => item.labels?.includes(label.id)).map((item) => item.name)
  return {
    ...item,
    labels: calculatedLabels,
  }
})
